import * as z from "zod/v4";

const BrightpearlServiceMappingSchema = z.object({
  brightpearlShippingMethodId: z.number(),
  carrier: z.string(),
  service: z.string().optional(),
});

export const updateBrightpearlOmsSettings = {
  name: "updateBrightpearlOmsSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    defaultShippingMethodId: z.number().nullish(),
    serviceMappings: z.array(BrightpearlServiceMappingSchema).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
